import TooltipPositioner from 'components/TooltipPositioner';
import 'containers/NewWordsFrame/index.scss';
import SvgObject from 'containers/NewWordsFrame/SvgObject';
import Tooltip, {TTooltipCur} from 'containers/Tooltip/Container';
import React, {FC, useCallback, useState} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';

const b = flatBem('NewWordsFrame');

type Props = {
  data: {svg: string};
  conf: Configurator;
};

const Component: FC<Props> = ({data, conf}) => {
  const [tooltipCur, setTooltipCur] = useState<TTooltipCur | null>(null);

  const svgParentRef = useCallback(
    node => {
      if (node === null) return;
      new SvgObject(data.svg, node, conf('isMobile', false), setTooltipCur).activate();
    },
    [data.svg, conf],
  );

  return (
    <div className={b()}>
      <div className={b('title')}>Недавние приобретения</div>
      <div className={b('text-after-title')}>
        Примеры слов, которые ни разу не встретились в дневниковых записях первых сорока лет XX
        века. Наведитесь на карточку слова, чтобы прочитать комментарий лингвиста.
      </div>
      <div className={b('svg-parent-parent')}>
        <div className={b('svg-parent')} ref={svgParentRef} />
      </div>
      <div className={b('copyright')}>
        <div className={b('copyright-line-1')}>
          По данным Яндекс.Дзена, 2019–2021, и центра <a href="">Прожито</a> ЕУСПб, 1900–1940.
        </div>
        <div className={b('copyright-line-2')}>
          <a href="https://milab.s3.yandex.net/2021/old-words/data/RussianNewWordsDataset.zip">
            Скачать таблицу
          </a>{' '}
          с 1000 слов, которые не встречаются в дневниковых записях первых сорока лет XX века
        </div>
      </div>
      <TooltipPositioner target={tooltipCur?.target ?? null}>
        <Tooltip cur={tooltipCur} />
      </TooltipPositioner>
    </div>
  );
};

export default Component;
